import { render, staticRenderFns } from "./leftLabelList.vue?vue&type=template&id=9501f2ce&scoped=true&"
import script from "./leftLabelList.vue?vue&type=script&lang=js&"
export * from "./leftLabelList.vue?vue&type=script&lang=js&"
import style0 from "./leftLabelList.vue?vue&type=style&index=0&id=9501f2ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9501f2ce",
  null
  
)

export default component.exports